// Global Imports
import styled from "styled-components";
import Stack from "react-bootstrap/Stack"

export const MealPlannerWrapper = styled.div``;

export const MealPlannerContent = styled(Stack)``;